export default "__VITE_ASSET__cdf4ca1c__"